"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./LinkCard.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _checkForRenderAnchorTag = require("../../utils/methods/checkForRenderAnchorTag");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/methods/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LinkCard = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    header,
    text,
    link,
    color,
    Link
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  const componentJSX = () => {
    return /*#__PURE__*/_react.default.createElement("article", {
      className: "ter-link-card"
    }, header && /*#__PURE__*/_react.default.createElement("h4", {
      className: "ter-link-card__header",
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
    }), text && (0, _checkForDangerouslySet.checkAndSet)(text, "ter-link-card", "text"), /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: link.url,
      className: "ter-link-card__link",
      tabIndex: mouse ? "" : "0",
      Link: Link
    }, link.text, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "enclosed-arrow-right-dark-32px",
      size: "32px",
      color: color ? color : "#242D2F"
    })));
  };
  return componentJSX();
};
var _default = LinkCard;
exports.default = _default;
LinkCard.propTypes = {
  content: _propTypes.default.shape({
    header: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    link: _propTypes.default.shape({
      url: _propTypes.default.string.isRequired,
      text: _propTypes.default.string.isRequired
    }).isRequired
  })
};